import {
  generateBindings,
  observableValue,
  useSharedState,
  view,
  View,
} from '@esui/core';
import { spread } from '@esui/core/utils/spread.js';
import '@material/mwc-dialog';
import { Dialog as MwcDialog } from '@material/mwc-dialog';
import { html } from 'lit';

export const [Dialog] = view('esui-mwc-dialog', {
  Props: class {
    content?: View = undefined;
    primaryAction?: [string, View] | View = undefined;
    secondaryAction?: [string, View] | View = undefined;
    open = observableValue(false);
    heading?: string = undefined;
    hideActions = false;
    stacked = false;
    scrimClickAction = 'close';
    escapeKeyAction = 'close';
    defaultAction = 'close';
    actionAttribute = 'dialogAction';
    initialFocusAttribute = 'dialogInitialFocus';
    onOpening?: () => void = undefined;
    onOpened?: () => void = undefined;
    onClosing?: (e: { detail: { action: string } }) => void = undefined;
    onClosed?: (e: { detail: { action: string } }) => void = undefined;
  },

  mapBuilder: DialogBuilder => (content: View) =>
    DialogBuilder().content(content),

  template(props) {
    const open = useSharedState(props.open);
    const computedProps = generateBindings(props, [
      'content',
      'primaryAction',
      'secondaryAction',
      'open',
      'onClosed',
    ]);

    function action(level: string, control: [string, View] | View | undefined) {
      if (typeof control === 'undefined') {
        return undefined;
      }
      if (control instanceof View) {
        return control.slot(level).body;
      }
      return control[1]
        .attr({ [props.actionAttribute]: control[0] })
        .slot(level).body;
    }

    function handleOnClosed(e: { detail: { action: string } }) {
      open.value = false;
      props.onClosed?.(e);
    }

    return html`
      <mwc-dialog
        ?open="${open.value}"
        ${spread({ ...computedProps })}
        @closed="${handleOnClosed}"
      >
        ${props.content?.body} ${action('primaryAction', props.primaryAction)}
        ${action('secondaryAction', props.secondaryAction)}
      </mwc-dialog>
    `;
  },
  noShadow: true,
});

export function InitialFocus(content: View) {
  return content.attr('dialogInitialFocus', '');
}

export type MdcDialog = MwcDialog;
